/* eslint-disable react/no-array-index-key */
import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Label } from 'recharts';

import { colorByIndex, tooltipContent, localeTooltipValueFormatter } from './chartUtils';
import { renderValueInSegment } from './pieUtils';

const defaultColorFillHandler = (_, index) => colorByIndex(index);

// RightRevenue styled donut pie chart, with % in segments, title inside donut, and info on hover
const RRPieChart = ({
    title = null,
    maxHeight = 370,
    innerRadius = '45%',
    data,
    nameKey = 'key',
    dataKey = 'value',
    tooltipValueFormatter = localeTooltipValueFormatter,
    colorFillHandler = defaultColorFillHandler,
    labelFormatter = renderValueInSegment,
}) => (
    <ResponsiveContainer aspect={1} height="auto" maxHeight={maxHeight}>
        <PieChart>
            <Pie
                data={data}
                nameKey={nameKey}
                dataKey={dataKey}
                innerRadius={innerRadius}
                labelLine={false}
                label={labelFormatter}
                isAnimationActive={false}
            >
                {data.map((entry, index) => (
                    <Cell key={index} fill={colorFillHandler(entry, index)} />
                ))}
                {title ? <Label value={title} position="center" /> : null}
            </Pie>
            <Tooltip content={tooltipContent} formatter={tooltipValueFormatter} isAnimationActive={false} />
        </PieChart>
    </ResponsiveContainer>
);

export default RRPieChart;
